import React, { useState } from 'react';
import masterPlan from '../img/amenities-6.jpeg';
import floor1 from '../img/amenities-1.jpeg';
import floor2 from '../img/amenities-2.jpeg';
import floor3 from '../img/amenities-3.jpeg';
import floor4 from '../img/amenities-4.jpeg';
import EnquiryModal from './EnquiryModal';

const floorPlans = [
  { id: 1, img: floor1, title: 'Basement Floor Plan' },
  { id: 2, img: floor1, title: 'Ground Floor Plan' },
  { id: 3, img: floor3, title: '1st Floor Plan' },
  { id: 4, img: floor3, title: '2nd Floor Plan' },
];

const HoverImage = ({ src, alt, fullWidth }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="position-relative mx-auto mb-4"
      style={{
        width: '100%',
        maxWidth: fullWidth ? '100%' : '900px',
        marginTop: fullWidth ? '1rem' : undefined,
        marginBottom: fullWidth ? '1rem' : undefined,
        cursor: 'pointer',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <img
        src={src}
        alt={alt}
        className="img-fluid w-100"
        style={{ filter: 'blur(3px)' }}
      />
      {hovered && (
        <div
          className="position-absolute top-50 start-50 translate-middle bg-white rounded-circle p-4 d-flex justify-content-center align-items-center shadow"
          style={{ width: '80px', height: '80px' }}
        >
          <div className="fs-2 fw-bold">+</div>
        </div>
      )}
    </div>
  );
};

const SiteAndFloorPlan = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="container py-5">
      {/* Master Plan */}
      <h4 className="fw-bold mb-3">Emperia Icon Apartments Master Plan</h4>
      <div onClick={() => setShowModal(true)}>
        <HoverImage src={masterPlan} alt="Master Plan" fullWidth />
      </div>

      {/* Floor Plans */}
      <h4 className="fw-bold mt-5 mb-3">Emperia Icon Floor Plan</h4>
      <div className="row g-3">
        {floorPlans.map(({ id, img, title }) => (
          <div
            className="col-6 col-md-4 col-lg-3"
            key={id}
            onClick={() => setShowModal(true)}
          >
            <HoverImage src={img} alt={title} />
          </div>
        ))}
      </div>

      <EnquiryModal
        show={showModal}
        onClose={() => setShowModal(false)}
        formtitle=" Discover More"
      />
    </div>
  );
};

export default SiteAndFloorPlan;
